<template>
  <div class="row">
    <div class="col-12">
      <user-table />
    </div>
  </div>
</template>

<script>
import UserTable from "@/views/components/users/table";
export default {
  name: "UsersList",
  components: { UserTable },
};
</script>